// initial state
const state = () => ({
  active_image: '',
});

// getters
const getters = {
  getActiveImage: (state) => {
    return state.active_image
  },
};

// actions
const actions = {
  activateImage({ commit }, image ) {
    commit("activateImage", { image });
  },
};

// mutations
const mutations = {
  activateImage(state, { image }) {
    state.active_image = image
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
